import { action, makeObservable, observable } from 'mobx';
import { computedFn } from 'mobx-utils';
import MessageType from '../models/messageType';
import processIncomingData from '../processIncomingData';

class MessageTypeStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable messageTypes = [];

  computedGetByTypeId = computedFn(function computedGetByTypeId(typeId) {
    return this.messageTypes.find((f) => f.TypeId === typeId);
  });

  @action UpsertAndGet(incObj) {
    return processIncomingData(incObj, this.rootStore, this.messageTypes, MessageType);
  }
}

export default MessageTypeStore;
